import { Box, Grid, Typography } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import LabCompanyApi from 'api/setting/default-labs/lab-company.api'
import LabGroupsApi from 'api/setting/default-labs/lab-group.api'
import { PACKAGE_ADDONS } from 'constants/package'
import { checkAddons, checkPackage, getBranch, getClinicInfo, getSecureItem, setSecureItem, toBuddhistYear } from 'utils/app.utils'

/** COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import { useDownloadExcel } from 'component/Excel/hooks/useExcel'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import Loading from 'component/Loading'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import RemunerationClinicFeeDentistDccList from './RemunerationClinicFeeDentistDccList'

/** STYLE */
import * as UseStyled from 'features/report/useStyled'

import { KEY_STORAGE } from 'constants/common'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import { useDispatch } from 'react-redux'
import { UseSnCode } from 'utils/useSnCode'
import { ReportFormulaDF } from '../report-option-df'
import { ExportClinicFeeDentistDcc } from './ExportDfToExcel'
import { ExportClinicFeeDentistDccPdf } from './ExportDfToPdf'

type Doctors = {
  userId: number
  firstname: string
  lastname: string
  fullname: string
}

interface DentistInterface {
  dentistId: number
  dentistFullname: string
}

export default function RemunerationClinicFeeDentistDcc() {
  const { t } = useTranslation()
  const history = useHistory()
  const componentRef = useRef<HTMLDivElement>(null)
  const momentNowRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  const momentDate = () => momentNowRange
  const dispatch = useDispatch()

  const [branchId, setBranchId] = useState<any>(getBranch())
  const [branches, setBranches] = useState<any[]>([])
  const [rowCount, setRowCount] = useState<number>(0)
  const [sortBy, setSortBy] = useState<string>('createAt')
  const [sortType, setSortType] = useState<string>('ASC')
  const [loading, setLoading] = useState<boolean>(true)
  const [rangeDate, setRangeDate] = useState<string[]>(momentDate)
  const [receiptPrefix, setReceiptPrefix] = useState<any[]>([])
  const [prefix, setPrefix] = useState('ALL')
  const [selectedOptionPrice, setSelectedOptionPrice] = useState<any>(getSecureItem(KEY_STORAGE.REPORT_CONDITION) || 'TREATMENT')

  const [doctorsMultiple, setDoctorsMultiple] = useState<DentistInterface[]>([])
  const [doctors, setDoctors] = useState<Doctors[]>([])
  const [selectDoctors, setSelectDoctors] = useState<any[]>(['ALL'])
  const [openFilterDoctors, setOpenFilterDoctors] = useState(false)

  const [labGroup, setLabGroup] = useState<any[]>([])
  const [labCompany, setLabCompany] = useState<any[]>([])
  const [labGroupId, setLabGroupId] = useState<number>(0)
  const [labCompanyId, setLabCompanyId] = useState<number>(0)

  const [optionDf, setOptionDf] = useState<'0' | '1' | '2' | '3'>('1')

  const [remunerationCfDentistData, getRemunerationCfDentistData] = useState<any>({})
  const [remunerationCfDentistPage, setRemunerationCfDentistPage] = useState<number>(1)
  const [remunerationCfDentistTypePage, setRemunerationCfDentistTypePage] = useState<number>(1)
  const [remunerationCfDentistLimitPage, setRemunerationCfDentistLimitPage] = useState<number>(10)
  const [checkDF, setCheckDF] = useState<boolean>(false)
  const [totalSummary, setTotalSummary] = useState<any>(null)

  const [popFormula, setPopFormula] = useState<boolean>(false)
  const [imageFormula, setImageFormula] = useState<string>('')

  const branchInfo = getClinicInfo()

  const [snType, setSnType] = useState(false)

  const handleSnCode = useCallback(() => {
    const fetchData = async () => {
      const sn = await UseSnCode()
      setSnType(sn)
    }

    fetchData()
  }, [snType])

  useEffect(() => {
    handleSnCode()
  }, [])


  useEffect(() => {
    setSecureItem(KEY_STORAGE.REPORT_CONDITION, (branchInfo?.defaultDfReport || '0').toString())
    setSelectedOptionPrice(branchInfo?.defaultDfReport || '0')
    setOptionDf(branchInfo?.defaultDfCon || '1')
  }, [branchInfo])

  const verifyPermission = async () => {
    const condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 200
    }
    setOptionDf(getClinicInfo().defaultDfCon)
    ReportApi.reportList(condition).then(({ data }) => {
      const check = _.find(data, (val: any) => String(val.reportKey) === 'REMUNERATION_CLINIC_FEE_ALL_DENTIST_DCC') ? true : false
      if (!check) {
        history.push(routeName.report)
        return false
      }
    })

    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(data))
      .catch((e) => {
        return
      })

    ClinicApi.allBillPrefix()
      .then((resp) => setReceiptPrefix(resp.data))
      .catch((e) => {
        return
      })

    // โหลดรายชื่อหมอ ย้ายไป useEffect เดียวด้านล่าง (loader เดียว — กรองตามสาขา + ช่วงวันที่)

    LabGroupsApi.findAll({ page: 1, pageLimit: 100, status: 'ACTIVE' })
      .then(({ data: dataLabGroup }) => {
        setLabGroup([{ labGroupId: 0, labGroupName: t('REPORT.FILTER.ALL') }, ...dataLabGroup])
      })
      .catch((e) => {
        return
      })

    LabCompanyApi.findAll({ page: 1, pageLimit: 100, status: 'ACTIVE' })
      .then(({ data: dataLabCompany }) => {
        setLabCompany([{ labCompanyId: 0, labCompanyName: t('REPORT.FILTER.ALL') }, ...dataLabCompany])
      })
      .catch((e) => {
        return
      })

    return true
  }

  useEffect(() => {
    verifyPermission()
  }, [branchId])

  // โหลดรายชื่อหมอ — loader เดียว กรองตามสาขา (branchId) + ช่วงวันที่ที่เลือก
  // ใส่ option "ไม่ระบุแพทย์" (999999) ในรายการเสมอ เพื่อให้ติ๊กเลือก + แสดงชื่อได้
  useEffect(() => {
    if (rangeDate[1] === 'Invalid date' || !rangeDate[1]) return
    const bId = branchId === 0 ? undefined : branchId
    ClinicApi.findAllDoctors('', '', rangeDate[0], rangeDate[1], bId)
      .then((resp) => {
        const dentists: DentistInterface[] = resp.data.map((d: any) => ({
          dentistId: d.userId,
          dentistFullname: d.fullname
        }))
        setDoctors([{ userId: 999999, firstname: '', lastname: '', fullname: t('REPORT.TITLE.NO_DOCTOR') }, ...resp.data])
        setDoctorsMultiple(dentists)
        setSelectDoctors(['ALL', ...dentists.map((d: DentistInterface) => d.dentistId)])
      })
      .catch((e) => {
        return
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId, rangeDate[0], rangeDate[1]])

  const fetchRemunerationClinicFeeDcc = useCallback(() => {
    setLoading(true)
    let condition: FindAllReportInterface = {
      page: remunerationCfDentistPage,
      pageLimit: remunerationCfDentistLimitPage,
      branchId: branchId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      labCompanyId: labCompanyId,
      labGroupId: labGroupId,
      optionPrice: selectedOptionPrice
    }

    if (selectDoctors) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (doctor) condition = { ...condition, doctorId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
    }
    if (prefix) condition = { ...condition, prefix: prefix === 'ALL' ? '' : prefix }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (optionDf) condition = { ...condition, optionDf: Number(optionDf) }
    if (rangeDate) {
      if ((rangeDate[0] !== null || rangeDate[0] !== '') && (rangeDate[1] !== null || rangeDate[1] !== '')) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    }

    ReportApi.reportRemittanceClinicFeeAllDentistDcc(condition)
      .then(({ headers, data }) => {
        getRemunerationCfDentistData(data)
        setRowCount(headers['x-total'])

        fetchTotalSummary()
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
  }, [sortBy, sortType, branchId, labCompanyId, labGroupId, remunerationCfDentistTypePage, remunerationCfDentistPage, remunerationCfDentistLimitPage, rangeDate, selectDoctors, prefix, doctors, optionDf, selectedOptionPrice])

  const fetchTotalSummary = useCallback(async () => {
    let condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 10000,
      branchId: branchId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      labCompanyId: labCompanyId,
      labGroupId: labGroupId,
      optionPrice: selectedOptionPrice
    }

    if (selectDoctors) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (doctor) condition = { ...condition, doctorId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
    }
    if (prefix) condition = { ...condition, prefix: prefix === 'ALL' ? '' : prefix }
    if (optionDf) condition = { ...condition, optionDf: Number(optionDf) }
    if (rangeDate) {
      if ((rangeDate[0] !== null || rangeDate[0] !== '') && (rangeDate[1] !== null || rangeDate[1] !== '')) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    }

    try {
      const { data } = await ReportApi.reportRemittanceClinicFeeAllDentistDcc(condition)
      if (data?.rawRows) {
        const summary = {
          paidTx: _.sumBy(data.rawRows, 'paidTx') || 0,
          cfPaid: _.sumBy(data.rawRows, 'cfPaid') || 0,
          dfPaid: _.sumBy(data.rawRows, 'dfPaid') || 0,
          paidMed: _.sumBy(data.rawRows, 'paidMed') || 0,
          paidPd: _.sumBy(data.rawRows, 'paidPd') || 0,
          paidMat: _.sumBy(data.rawRows, 'paidMat') || 0,
          paidSt: _.sumBy(data.rawRows, 'paidSt') || 0,
          paidXray: _.sumBy(data.rawRows, 'paidXray') || 0,
          amountPaid: _.sumBy(data.rawRows, 'amountPaid') || 0,
          amountCash: _.sumBy(data.rawRows, 'amountCash') || 0,
          amountTransfer: _.sumBy(data.rawRows, 'amountTransfer') || 0,
          amountDebit: _.sumBy(data.rawRows, 'amountDebit') || 0,
          amountCredit: _.sumBy(data.rawRows, 'amountCredit') || 0,
          creditCost: _.sumBy(data.rawRows, 'creditCost') || 0,
          amountTreatmentRight: _.sumBy(data.rawRows, 'amountTreatmentRight') || 0,
          amountAdvance: _.sumBy(data.rawRows, 'amountAdvance') || 0
        }

        setTotalSummary(summary)
      }
    } catch (e) {
      console.error('Error fetching total summary:', e)
    }
  }, [branchId, labCompanyId, labGroupId, rangeDate, selectDoctors, prefix, optionDf, selectedOptionPrice])

  const setDoc = (data: any) => {
    const sortedSelectData = data.sort((a: any, b: any) => {
      const idA = a.dentistId
      const idB = b.dentistId
      return selectDoctors.indexOf(idA) - selectDoctors.indexOf(idB)
    })
    return sortedSelectData
  }

  const filter = [
    branchId === 0 ? `${t(`REPORT.FILTER.ALL`)}` : `${_.get(_.find(branches, { branchId: branchId }), 'branchName') || _.get(_.find(branches, { branchId: branchId }), 'branchNameEn')}`,
    toBuddhistYear(moment(rangeDate[0]), 'DD/MM/YYYY'),
    toBuddhistYear(moment(rangeDate[1]), 'DD/MM/YYYY'),
    prefix === 'ALL' ? `${t(`REPORT.FILTER.ALL`)}` : prefix,
    _.isEmpty(selectDoctors) || _.includes(selectDoctors, '')
      ? ` ${t('REPORT.FILTER.NO_SELECT')}`
      : _.includes(selectDoctors, 'ALL')
        ? `${t('REPORT.FILTER.ALL')}`
        : `${setDoc(doctorsMultiple.filter((d: any) => selectDoctors.includes(d.dentistId)))
          ?.map((d: any) => d.dentistFullname)
          .slice(0, 3)
          .join(', ')}`,
    labGroupId ? `${_.get(_.find(labGroup, { labGroupId: labGroupId }), 'labGroupName') || _.get(_.find(labGroup, { labGroupId: labGroupId }), 'labGroupNameEn')} ` : `${t(`REPORT.FILTER.ALL`)}`,
    labCompanyId ? `${_.get(_.find(labCompany, { labCompanyId: labCompanyId }), 'labCompanyName') || _.get(_.find(labCompany, { labCompanyId: labCompanyId }), 'labCompanyNameEn')} ` : `${t(`REPORT.FILTER.ALL`)}`,
    optionDf === '0' ? t('REPORT.FILTER.NO_CAL_DF') : t(`REPORT.FILTER.DF${optionDf}`)
  ]

  const { onDownload } = useDownloadExcel({
    tableExportRef: componentRef.current,
    filename: `${t(`REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE_ALL_DENTIST_DCC`)} (${rangeDate[0]} - ${rangeDate[1]})`,
    sheetName: `${t(`REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE_ALL_DENTIST_DCC`)}`
  })

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangeRowsPerPage = (limit: number) => setRemunerationCfDentistLimitPage(limit)

  const handleChangePage = (val: number) => setRemunerationCfDentistPage(val)

  useEffect(() => {
    fetchRemunerationClinicFeeDcc()
  }, [sortBy, sortType, remunerationCfDentistPage, remunerationCfDentistLimitPage, selectDoctors])

  useEffect(() => {
    fetchTotalSummary()
  }, [branchId, labCompanyId, labGroupId, rangeDate, selectDoctors, prefix, optionDf, selectedOptionPrice])

  useEffect(() => {
    if (imageFormula === '') {
      setPopFormula(false)
    } else {
      setPopFormula(true)
    }
  }, [imageFormula])

  const fetchRemunerationClinicFeeDccExport = useCallback(async () => {
    setLoading(true)
    let condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 10000,
      branchId: branchId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      labCompanyId: labCompanyId,
      labGroupId: labGroupId,
      optionPrice: selectedOptionPrice
    }

    if (selectDoctors) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (doctor) condition = { ...condition, doctorId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
    }
    if (prefix) condition = { ...condition, prefix: prefix === 'ALL' ? '' : prefix }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (optionDf) condition = { ...condition, optionDf: Number(optionDf) }
    if (rangeDate) {
      if ((rangeDate[0] !== null || rangeDate[0] !== '') && (rangeDate[1] !== null || rangeDate[1] !== '')) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    }

    try {
      const { data } = await ReportApi.reportRemittanceClinicFeeAllDentistDcc(condition)
      return data
    } catch (e) {
      return null
    } finally {
      setLoading(false)
    }
  }, [sortBy, sortType, branchId, labCompanyId, labGroupId, rangeDate, selectDoctors, prefix, optionDf, selectedOptionPrice])

  const handleExport = async () => {
    const exportData = await fetchRemunerationClinicFeeDccExport()
    if (!exportData) return

    const report: any = {
      branchName: filter[0],
      dateStart: filter[1],
      dateEnd: filter[2],
      receiptPrefix: filter[3],
      doctorsFilter: filter[4],
      labGroupName: filter[5],
      labCompanyName: filter[6],
      includeSn: snType,
      data: exportData,
      doctors: doctorsMultiple,
      t: t
    }
    ExportClinicFeeDentistDcc(report)
  }

  const handleExportPdf = async () => {
    const exportData = await fetchRemunerationClinicFeeDccExport()
    if (!exportData) return

    const report: any = {
      branchName: filter[0],
      dateStart: filter[1],
      dateEnd: filter[2],
      receiptPrefix: filter[3],
      doctorsFilter: filter[4],
      labGroupName: filter[5],
      labCompanyName: filter[6],
      includeSn: snType,
      data: exportData,
      doctors: doctorsMultiple,
      t: t
    }
    ExportClinicFeeDentistDccPdf(report)
  }

  if (!checkAddons(PACKAGE_ADDONS.ADDON_DCC)) {
    return (
      <Box sx={{ p: 3 }}>
        <HeaderCard text={t(`REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE_ALL_DENTIST_DCC`)} />
        <Box sx={{ py: 2 }}>
          <Typography color="text.secondary">{t('REPORT.NO_PERMISSION_ADDON') || 'ไม่มีสิทธิ์ใช้งานรายงานนี้ (ต้องเปิดใช้ฟีเจอร์ค่า DCC)'}</Typography>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      <HeaderCard text={t(`REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE_ALL_DENTIST_DCC`)} />
      <Box padding="16px">
        <Grid container spacing="8px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              label={t('REPORT.FILTER.BRANCH')}
              value={branchId}
              onChange={e => {
                setBranchId(e.target.value)
                setRemunerationCfDentistPage(1)
              }}
              options={branches.map(b => ({
                value: b.branchId,
                name: b.branchName || b.branchNameEn || ''
              }))}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <InputSecondNewRangePicker
              inputHeight={40}
              value={rangeDate || emptyRangePicker}
              onchange={(val: any) => {
                setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
              }}
              label={''}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(e) => {
                setPrefix(e.target.value)
                setRemunerationCfDentistPage(1)
                setRemunerationCfDentistTypePage(1)
              }}
              value={prefix}
              options={[{ value: 'ALL', name: t('REPORT.FILTER.ALL') },
              ...receiptPrefix.map(b => ({
                value: b.prefix,
                name: b.prefix
              }))
              ]}
              label={t('REPORT.FILTER.RECEIPT_TYPE')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectCheckBoxInput
              label={t('USER_DOCTOR')}
              options={doctors.map((d: any) => ({
                id: d.userId,
                name: d.fullname
              }))}
              selected={selectDoctors}
              onChange={(ids: any) => {
                setSelectDoctors(ids)
                setOpenFilterDoctors(false)
              }}
              fullWidth
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <AutocompleteSelect
              key={'lab-group'}
              labelId="lab-group"
              inputLabel={t('REPORT.FILTER.LAB_GROUP')}
              noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
              options={labGroup}
              getOptionLabel={(option: any) => option.labGroupName || ''}
              renderOption={(props, option: any) => (
                <Box key={option.labGroupId} component="li" {...props}>
                  {option.labGroupName}
                </Box>
              )}
              onchange={(e, value: any) => {
                setLabGroupId(value?.labGroupId || 0)
              }}
              value={_.find(labGroup, (val: any) => Number(val.labGroupId) === Number(labGroupId)) || labGroup[0] || null}
              disableClearable
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <AutocompleteSelect
              key={'lab-company'}
              labelId="lab-company"
              inputLabel={t('REPORT.FILTER.LAB_COMPANY')}
              noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
              options={labCompany}
              getOptionLabel={(option: any) => option.labCompanyName || ''}
              renderOption={(props, option: any) => (
                <Box key={option.labCompanyId} component="li" {...props}>
                  {option.labCompanyName}
                </Box>
              )}
              onchange={(e, value: any) => {
                setLabCompanyId(value?.labCompanyId || 0)
              }}
              value={_.find(labCompany, (val: any) => Number(val.labCompanyId) === Number(labCompanyId)) || labCompany[0] || null}
              disableClearable
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={12}>
            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
              <MainButton onClick={() => fetchRemunerationClinicFeeDcc()} title={t('INPUT.SEARCH')} type='primary' variant='contained' style={{ width: '120px' }}></MainButton>
              <UseStyled.DropdownDocument>
                <Dropdown.Toggle id="dropdown-basic" className="ml-xl-auto">
                  {t('REGISTER.BUTTON.PRINT_DOCUMENT')}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={handleExport}>{t('Excel')}</Dropdown.Item>
                  <Dropdown.Item onClick={handleExportPdf}>{t('PDF')}</Dropdown.Item>
                </Dropdown.Menu>
              </UseStyled.DropdownDocument>
            </Box>
          </Grid>
        </Grid>
        <Box className={'mt-3 pl-xl-3 pr-xl-2 pb-4'}>
          <RemunerationClinicFeeDentistDccList
            page={remunerationCfDentistPage}
            pageLimit={remunerationCfDentistLimitPage}
            rowCount={rowCount}
            sortBy={sortBy}
            sortType={sortType}
            data={remunerationCfDentistData}
            doctors={doctorsMultiple}
            onRequestSort={onRequestSort}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            filter={filter}
            filterDateStart={rangeDate[0]}
            filterDateEnd={rangeDate[1]}
            componentRef={componentRef}
            totalSummary={totalSummary}
          />
        </Box>
      </Box>

      <Loading show={loading} type="fullLoading" />
      {popFormula && imageFormula !== '' && <ReportFormulaDF img={imageFormula} setImg={setImageFormula} />}
    </Box>
  )
}
